<template lang="pug">
.balance
    h3.balance__text {{ $t('payments.balance') }}:
    h2.balance__amount {{ balance | currency }}
</template>

<script>
export default {
  name: 'DashboardBalance',
  props: {
    invoices: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    balance: function () {
      let balance = this.invoices
        .reduce((acc, item) => {
          return parseFloat(acc) + parseFloat(item.balance)
        }, 0)
        .toFixed(2)
      let amount = this.invoices
        .reduce((acc, item) => {
          return parseFloat(acc) + parseFloat(item.amount)
        }, 0)
        .toFixed(2)
      return amount - balance
    }
  }
}
</script>

<style lang="scss">
.balance {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 3rem 5rem;
    &__text {
        font-size: 16px;
        font-weight: 600;
        line-height: 24px;
        letter-spacing: 0em;
        text-align: left;
        color: #EB5757;
    }
    &__amount {
        font-size: 32px;
        font-weight: 700;
        line-height: 48px;
        letter-spacing: 0em;
        text-align: left;
        color: #EC2028;
    }
}
</style>
